import { getFunctions, httpsCallable } from 'firebase/functions'
import { UserCoach } from 'fitify-types/src/types/functions'
import { toast } from 'fitify-ui-onboarding/src/components'
import { getNavigatorLocale } from 'fitify-ui-onboarding/src/utils'

import { IDataState } from 'utils/state'

export const createUserProfile = async (data: IDataState): Promise<boolean> => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [language, country] = getNavigatorLocale().split('-')

  // _ indicates to unset variable in spreading
  const { coaches: _, ...profileData } = data

  const userData = {
    ...profileData,
    locale: {
      timezone,
      language,
      country,
    },
    newsletter: true,
  }

  try {
    await httpsCallable(getFunctions(), 'createHcUserProfile')(userData)
    return true
  } catch (err) {
    console.error(err)
    toast({
      type: 'error',
      content: 'Failed to create user profile',
    })
  }

  return false
}

export const updateCoachId = async (coachId: string | null) => {
  await httpsCallable<UserCoach.UpdateId.Request, UserCoach.UpdateId.Response>(
    getFunctions(),
    'updateUserCoachId'
  )({ selected_coach_id: coachId })
}

export const updateTopMatchCoachId = async (coachId: string) => {
  try {
    await httpsCallable<
      UserCoach.UpdateId.Request,
      UserCoach.UpdateId.Response
    >(
      getFunctions(),
      'updateUserCoachId'
    )({ top_match_coach_id: coachId })
  } catch (err) {
    console.error('Failed to update top match coach', err)
  }
}
